import { render, staticRenderFns } from "./ColumnsFilter.vue?vue&type=template&id=86bfca5a&scoped=true"
import script from "./ColumnsFilter.vue?vue&type=script&lang=js"
export * from "./ColumnsFilter.vue?vue&type=script&lang=js"
import style0 from "./ColumnsFilter.vue?vue&type=style&index=0&id=86bfca5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bfca5a",
  null
  
)

export default component.exports